import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { draftLeadColumns, lockedDraftLeadColumns } from './draftLeadColumns'
import {
  selectDraftLeadColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'
import { arrangeColumns } from '@user/components/xGrid'
import {
  useSelectCustomFieldData,
  useGetCustomFieldsOnMount,
} from '@user/store/customFields'
import { useAddMissingColumns } from '@user/components/xGrid/valueFormatters/syncNewColumns'
import { useMapViewFeatureEnabled } from '@user/store/tenantFeatures/hooks/useMapViewFeatureEnabled'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'

export function useGetColumnData() {
  const prefsLoading = useLoadListViewPreferencesOnce()
  const customFieldsLoading = useGetCustomFieldsOnMount()

  const mapViewEnabled = useMapViewFeatureEnabled()
  const d2DKnockEnabled = useD2DKnockEnabled()
  const knockStatusEnabled = mapViewEnabled && d2DKnockEnabled

  const { customFields } = useSelectCustomFieldData()
  const columnOrder = useSelector(selectDraftLeadColumnOrder)

  const [columns, columnVisibility] = useMemo(
    () =>
      arrangeColumns(
        columnOrder,
        draftLeadColumns(knockStatusEnabled),
        lockedDraftLeadColumns,
        customFields,
      ),
    [columnOrder, customFields, knockStatusEnabled],
  )

  const { syncNewColumnsWithPreferences } = useAddMissingColumns({
    columnOrder,
    columns,
    newlyAddedColumns: knockStatusEnabled
      ? ['knockStatus', 'knockStatusReason']
      : [],
    preference: 'draft',
  })

  useEffect(() => {
    syncNewColumnsWithPreferences()
  }, [columnOrder, syncNewColumnsWithPreferences])

  const colsLoading = prefsLoading || customFieldsLoading

  return {
    columns,
    colsLoading,
    columnVisibility,
  }
}
